import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCalculator, FiShare2, FiPrinter, FiRefreshCw, FiPlus, FiX } = FiIcons;

const MobileFAB = ({ 
  onCalculate, 
  onShare, 
  onPrint, 
  onReset, 
  results, 
  isCalculating 
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const actions = [
    {
      icon: FiShare2,
      label: 'Share',
      action: onShare,
      show: !!results,
      color: 'bg-blue-500'
    },
    {
      icon: FiPrinter,
      label: 'Print',
      action: onPrint,
      show: !!results,
      color: 'bg-green-500'
    },
    {
      icon: FiRefreshCw,
      label: 'Reset',
      action: onReset,
      show: true,
      color: 'bg-gray-500'
    }
  ];

  return (
    <div className="fixed bottom-6 right-6 z-40 md:hidden">
      <AnimatePresence>
        {isExpanded && (
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.8 }}
            className="absolute bottom-16 right-0 space-y-3"
          >
            {actions.filter(action => action.show).map((action, index) => (
              <motion.button
                key={index}
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: 20 }}
                transition={{ delay: index * 0.1 }}
                whileTap={{ scale: 0.9 }}
                onClick={() => {
                  action.action();
                  setIsExpanded(false);
                }}
                className={`
                  ${action.color} text-white p-3 rounded-full shadow-lg
                  flex items-center justify-center min-w-[48px] h-12
                `}
                aria-label={action.label}
              >
                <SafeIcon icon={action.icon} className="text-lg" />
              </motion.button>
            ))}
          </motion.div>
        )}
      </AnimatePresence>

      {/* Main FAB */}
      <motion.button
        whileTap={{ scale: 0.9 }}
        onClick={() => {
          if (isExpanded) {
            setIsExpanded(false);
          } else if (results) {
            setIsExpanded(true);
          } else {
            onCalculate();
          }
        }}
        disabled={isCalculating}
        className={`
          bg-blue-600 text-white p-4 rounded-full shadow-lg
          flex items-center justify-center w-14 h-14
          ${isCalculating ? 'opacity-70' : ''}
        `}
        aria-label={results ? "More actions" : "Calculate"}
      >
        <AnimatePresence mode="wait">
          {isCalculating ? (
            <motion.div
              key="loading"
              initial={{ opacity: 0, rotate: 0 }}
              animate={{ opacity: 1, rotate: 360 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
            >
              <SafeIcon icon={FiRefreshCw} className="text-xl" />
            </motion.div>
          ) : results ? (
            <motion.div
              key="expanded"
              initial={{ opacity: 0, rotate: -90 }}
              animate={{ opacity: 1, rotate: isExpanded ? 45 : 0 }}
              exit={{ opacity: 0, rotate: 90 }}
            >
              <SafeIcon icon={isExpanded ? FiX : FiPlus} className="text-xl" />
            </motion.div>
          ) : (
            <motion.div
              key="calculate"
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.8 }}
            >
              <SafeIcon icon={FiCalculator} className="text-xl" />
            </motion.div>
          )}
        </AnimatePresence>
      </motion.button>
    </div>
  );
};

export default MobileFAB;